import { render } from "./Admin.vue?vue&type=template&id=2ed9d5f0"
import script from "./Admin.vue?vue&type=script&lang=ts"
export * from "./Admin.vue?vue&type=script&lang=ts"
script.render = render

export default script